import React from 'react';
import { Box } from '@material-ui/core';

interface TopBarItemProps {
  children: React.ReactNode;
  onMouseOver?: React.MouseEventHandler<HTMLDivElement>;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const TopBarItem: React.FC<TopBarItemProps> = ({ children, onMouseOver, onClick }) => {
  return (
    <Box
      mx={{ sm: 1, md: 2, lg: 2.5 }}
      onMouseOver={onMouseOver}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};

export default TopBarItem;
